<template>
  <v-col cols="12" sm="2">
    <div>
     {{displayedTimeStamp}}
    </div>
  </v-col>
</template>

<script>

export default {

  props: [
    'sharedTimeStamp',
    'locale'
  ],
  computed: {
    displayedTimeStamp () {
      let options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' };

      return this.sharedTimeStamp.toLocaleString(this.locale, options);
    }
  }
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/components/datepicker/TimeDisplay.vue